import { gql } from "@apollo/client"

export const MY_COUPONS = gql`
  query MyCoupons(
    $totalAmount: Float
    $dcId: ID
    $isOrder: Boolean
    $sellableItemStockId: ID
  ) {
    myCupons(
      totalAmount: $totalAmount
      dcId: $dcId
      isOrder: $isOrder
      sellableItemStockId: $sellableItemStockId
    ) {
      id
      name
      flat
      percentage
      discountConditions
    }
  }
`
